
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-core
* (C) Copyright IBM Corp. 2018, 2020
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'generalInfo': 'ทั่วไป',
	'widgetId': 'ID วิดเจ็ต',
	'widgetType': 'ชนิดของวิดเจ็ต',
	'serviceability': 'ความสามารถในการให้บริการ',
	'copyButton': 'คัดลอก',
	'closeButton': 'ปิด',
	'specification': 'ข้อมูลจำเพาะ',
	'viewSpecification': 'ดูข้อมูลจำเพาะ'
});
